import { Plugin, PluginType, } from '@segment/analytics-react-native';
export class LoggingPlugin extends Plugin {
    type = PluginType.after;
    execute(event) {
        console.log(`[ANALYTICS] analytics event sent to destination.`, event);
        return event;
    }
}
//# sourceMappingURL=LoggingPlugin.js.map